/**
 * Return `value` if it is an array; otherwise return `fallback` (default `[]`).
 *
 * Guards against API responses that occasionally serialize a list field as a
 * string or object, which would silently let chains like `value.slice(N).map(...)`
 * crash with the JS engine's "(intermediate value).map is not a function" error.
 * Prefer this at the boundary where API data enters render code.
 */
export function toArrayOr(value, fallback = []) {
  return Array.isArray(value) ? value : fallback
}
